<template>
	<div class="main-containter" id="top" v-title data-title="reservaion">
		<PHeader :checkId="'隐私政策'"  :activeNames="'隐私政策'"></PHeader>
		
		<article>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 </span>
				<span style="color:#333333;font-size:14px;"> / 隐私政策</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;text-align:left;width:94%;">隐私政策</div>
			<div style="margin-left: 3%;margin-top:0px;text-align:left;width:94%;;margin-top: 20px;line-height: 32px;font-size: 14px;color: #333333;">
				<div style="margin-top:20px;">《reservaion官方网站隐私政策》目录</div>
					<div>一、引言</div>
					<div>二、关于我们</div>
					<div>三、收集与使用个人信息</div>
					<div>四、我们如何保护您的个人信息</div>
					<div>五、您的权利</div>
					<div>六、政策更新</div>
					<div>七、联系我们</div>
					<div style="margin-top:50px;">一、引言</div>
					<div>1.1上海reservaion律师事务所（以下简称“reservaion”或“我们”）作为一家律师事务所，重视并致力于保护reservaion官方网站（以下简称“本网站”）访问用户（以下“您”）的个人信息，特别制定本网站隐私政策（以下简称“本隐私政策”）。</div>
					<div>1.2请您务必仔细阅读本隐私政策，您使用本网站、浏览本网站信息的行为将被视为您充分理解、明确同意本隐私政策的内容，并接受本隐私政策的约束。</div>
					<div style="margin-top:50px;">二、关于我们</div>
					<div>2.1本网站由上海reservaion律师事务所设立运营。本隐私政策仅适用于本网站，不适用于经由本网站访问的任何外部链接或站点。</div>
					<div>2.2reservaion的联系方式为：</div>
					<div>地址：河北省唐山市路北区建设北路96-1号</div>
					<div>电话：0315-2037777</div>
					<div>邮箱：chensi@hehualawyer.com</div>
					<div style="margin-top:50px;">三、收集与使用个人信息</div>
					<div>（一）通过“Cookie”技术收集的信息</div>
					<div>本网站使用了“Cookie”技术，以便我们能够了解您访问本网站的路径，记录您在本网站的活动，并对本网站进行评估和改进。通过“Cookie”技术收集的相关信息不含可识别个人身份的信息，主要包括：</div>
					<div>3.1您访问本网站的时间与次数等，您浏览本网站的相关记录，包括IP地址、电子设备信息、浏览本网站的搜索记录、访问的子页面、在每个网页或网站区域上的停留时间等；</div>
					<div>3.2与您、您的电子设备接入点和您用于连接至本网站的浏览器等相关的其他信息。</div>
					<div>注：大多数浏览器可以对是否启用Cookie进行初始设置，您也可以根据自己的需要删除浏览器特定时间段内所有或指定的Cookie。不过，需要注意的是，改变Cookie的设置可能会导致网站的某些区域或者功能无法正常使用或运行，删除Cookie可能会删除您之前在本网站所记录的相应信息或对它关联的服务产生部分影响。</div>
					<div>（二）个人信息的收集</div>
					<div>3.3当您使用本网站“联系我们”模块或其他我们公布的方式与我们联系时，即，您联系我们时，要求我们与您联系或向您提供信息时，或者您与我们的律师联系时，我们可能会收集您主动提供的以下信息：</div>
					<div>3.3.1联系信息：例如您的姓名、您的地址、电子邮件地址和电话号码；</div>
					<div>3.3.2由您提供的用以咨询或开展其他业务合作的背景信息，例如：个人身份信息，个人财产信息，与咨询、合作案件相关的其他信息等。</div>
					<div>3.4您可以根据自身实际需要以及本网站出现的提示，决定是否提供个人信息。当您决定提供时，请务必提供必要、真实、有效的信息。如提供不实信息，则可能导致无法获得回复、网站部分功能或区域无法正常使用等问题。另外，当您提供违法信息时，公安机关等相关政府机关可能对您展开调查。</div>
					<div>（三）个人信息使用</div>
					<div>3.5reservaion通过本网站收集个人信息的目的包括：</div>
					<div>3.5.1 统计网站的访问情况；</div>
					<div>3.5.2 确认您的身份与您咨询的内容；</div>
					<div>3.5.3 在您的要求下与您取得联系；</div>
					<div>3.5.4 向您提供订阅的内容； </div>
					<div>3.5.5满足法律法规强制性要求。</div>
					<div>（四）个人信息的共享或转让</div>
					<div>3.6为保障本网站的运营及相关信息安全，确保安全稳定地保管好本网站收集的个人信息，我们使用自行所有或符合相关安全标准的第三方信息安全管理机构或服务机构租赁的服务器，以存储个人信息的全部数据。</div>
					<div>3.7我们因业务或合作需要，依法向关联分所、合作方提供已收集的信息。满足上述情形时，我们将要求信息接收方以不低于我们的标准予以保密和使用。</div>
					<div>（五）个人信息的披露</div>
					<div>3.9未经您的事先同意，我们不会以营利为目的，披露已收集的可识别个人身份的信息，包括您的姓名、联系电话、公司名称等。</div>
					<div>3.10但在如下情形，我们可以不经您事先同意，直接向第三方披露：</div>
					<div>3.10.1 为配合公安机关、检察机关、司法机关及其他政府机关的工作，依据相关法律法规、法院判决、裁定等向其披露相关信息；</div>
					<div>3.10.2 为维护您、我们及其他社会公众的合法权益、社会公共利益免遭损害而披露；</div>
					<div>3.10.3 我们披露从合法、公开的途径获得的您的个人信息。</div>
					<div style="margin-top:50px;">四、我们如何保护您的个人信息</div>
					<div>4.1我们已经使用符合业界标准的安全防护措施保护您提供的个人信息，防止未经授权的访问、公开披露、使用、修改、损坏或丢失。但请注意，任何保护措施都无法做到万无一失，因软件病毒、黑客攻击、系统软硬件的损毁等非我们可控的原因，您的信息仍存在被恶意披露、使用，甚至损毁的风险。我们对此类风险不承担责任，相关风险由您自行承担，但我们在知晓该信息安全事件发生时，将及时采取措施防止您的损失扩大（如有）并将该等事件通知您，以便您可以快速采取防范应对措施。</div>
					<div>4.2我们会采取一切合理可行措施，确保未收集无关的个人信息。我们只会在达成本隐私政策目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律允许。对于不再存储的信息，我们将销毁或永久性删除或做匿名化处理。</div>
					<div>4.3我们采取负责任的态度及措施保护网站访问者的隐私，但是我们无法承诺当前在线应用程序的设计能够适应所有浏览器设置，或满足所有个人浏览器的首选项。请您了解互联网所固有的安全风险，并请妥善处理、披露您的个人信息。</div>
					<div>4.4我们根据相关法律法规规定和实际需要，原则上将个人信息存储在中华人民共和国境内。</div>
					<div>4.5我们根据相关法律法规规定，设定信息安全责任人负责个人信息的保护与管理工作。如有需要，您可以通过本隐私政策所载联系方式与我们取得联系。</div>
					<div style="margin-top:50px;">五、您的权利</div>
					<div>我们保障您在合理合法的范围内对您的个人信息行使以下权利：</div>
					<div>5.1 访问您的个人信息</div>
					<div>您有权访问您提交的个人信息。请您通过【链接：www.hehualawyer.com】页面或发送电子邮件至【邮箱：chensi@hehualawyer.com】，我们将在30天内回复您的请求。</div>
					<div>5.2 更正您的个人信息</div>
					<div>您有权更正您已经提交的个人信息。请您通过【链接：www.hehualawyer.com】页面或发送电子邮件至【邮箱：chensi@hehualawyer.com】，我们将在30天内回复您的请求。</div>
					<div>5.3 删除您的个人信息</div>
					<div>您有权在以下情形中向我们提出删除个人信息的请求：</div>
					<div>5.3.1如果我们处理个人信息的行为违反法律法规的强制性规定；</div>
					<div>5.3.2如果我们收集使用您的个人信息未经您的同意；</div>
					<div>5.3.3如果我们违反约定使用您的个人信息或改变用途；</div>
					<div>5.3.4如果您不再使用我们的产品或服务；</div>
					<div>5.3.5如果我们不再为您提供产品或服务。</div>
					<div>5.4 改变您授权同意的范围</div>
					<div>如果您不想接受我们给您发送的订阅内容或推送，请您通过【链接：www.hehualawyer.com】页面或发送电子邮件至【邮箱：chensi@hehualawyer.com】，我们将在30天内回复您的请求。</div>
					<div>5.5出于安全考虑，在您提出上述要求时，我们可能会请求您协助我们进行身份验证。</div>
					<div style="margin-top:50px;">六、政策更新</div>
					<div>6.1本隐私政策的解释权和修改权归上海reservaion律师事务所所有。</div>
					<div>6.2本隐私政策可能根据不时更新的相关法律法规之要求，reservaion的经营需要，以及本网站更新的技术要求等进行修订。</div>
					<div>6.3我们会及时将修订后的政策进行发布，而不做单独通知。该等修订可能会对您的权利与义务产生影响，建议您在每次访问本网站时均予以阅读、确认，及时了解更新。</div>
					<div style="margin-top:50px;">七、联系我们</div>
					<div>如果您对本隐私政策有任何疑问、意见或建议，可以通过【链接：www.hehualawyer.com】页面或发送电子邮件至【邮箱：chensi@hehualawyer.com】，我们将在30天内回复您的请求。</div>
					<div style="margin-top: 50px;text-align: right;">上海reservaion律师事务所</div>
					<div style="text-align: right;">2023年 5 月 17 日</div>
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
			}
		},
		mounted() {
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
/* Reset */
 .btn-border-o:before{
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

/* Main Styles */

.btn {
  position: relative;
}

.btn-border-o {
  background-color: transparent;    
  border: 0;
  border-bottom: 1px solid #d0d0d0;
  color: #B8B8B8;
}
.btn-border-o:before {
  content: '';
  border-style: solid;
  position: absolute;
  z-index: 5;
  box-sizing: content-box;
}
.btn-border-o:before {
  width: 0;
  height: 100%;
  border-width: 0 0 1px 0;
  top: -0.5px;
  left: 0;
}
.btn-border-o:hover:before {
  width: 100%;
}
.btn-border-o:hover:after {
  height: 100%;
}
.btn-border-o.btn-green:hover {
  color: #98273A;
}
</style>
